import React from 'react';

const DemoArchitecture: React.FC = () => {
  return (
    <div className="demo-architecture">
      <h2>Demo Architecture</h2>
      
      <section className="architecture-section">
        <h3>🌐 Serverless Web Application</h3>
        <ul>
          <li><strong>Frontend:</strong> React with AWS Amplify</li>
          <li><strong>Authentication:</strong> Amazon Cognito</li>
          <li><strong>API:</strong> API Gateway + Lambda</li>
          <li><strong>Storage:</strong> S3 + CloudFront</li>
        </ul>
        <p>
          <a href="https://aws.amazon.com/lambda/resources/refarch/refarch-webapp/" target="_blank" rel="noopener noreferrer">
            📐 AWS Serverless Web Application Reference Architecture
          </a>
        </p>
      </section>

      <section className="architecture-section">
        <h3>🤖 GenAI with Parakeet</h3>
        <ul>
          <li><strong>Model:</strong> Amazon Bedrock (Claude)</li>
          <li><strong>Use Case:</strong> Ingredient recognition from images</li>
          <li><strong>Emissions Calculation:</strong> Automated carbon footprint analysis</li>
        </ul>
        <p>
          <a href="https://github.com/amazon-science/carbon-assessment-with-ml/tree/main/parakeet" target="_blank" rel="noopener noreferrer">
            🦜 Parakeet - Carbon Assessment with ML
          </a>
        </p>
      </section>

      <section className="architecture-section">
        <h3>⚡ IoT Energy Monitoring</h3>
        <ul>
          <li><strong>Device:</strong> Smart plug with real-time power monitoring</li>
          <li><strong>Integration:</strong> AWS IoT Core</li>
          <li><strong>Data Pipeline:</strong> Kinesis Firehose → S3 (Parquet)</li>
          <li><strong>Processing:</strong> Lambda enrichment</li>
        </ul>
        <p>
          <a href="https://aws.amazon.com/blogs/iot/when-data-is-all-you-need-an-overview-of-iot-communication-with-the-cloud/" target="_blank" rel="noopener noreferrer">
            📡 IoT Communication with the Cloud
          </a>
        </p>
      </section>

      <section className="architecture-section">
        <h3>📊 Analytics & Visualization</h3>
        <ul>
          <li><strong>Data Lake:</strong> S3 with Glue Catalog</li>
          <li><strong>Query Engine:</strong> Amazon Athena</li>
          <li><strong>Dashboard:</strong> Amazon QuickSight</li>
        </ul>
        <p>
          <a href="https://docs.aws.amazon.com/prescriptive-guidance/latest/patterns/analyze-and-visualize-nested-json-data-with-amazon-athena-and-amazon-quicksight.html" target="_blank" rel="noopener noreferrer">
            📈 Analyze and Visualize Data with Athena and QuickSight
          </a>
        </p>
      </section>
    </div>
  );
};

export default DemoArchitecture;
